import { InputNumber } from 'primereact/inputnumber';
import React, { useState } from 'react';

interface EditNumberModel {
  title?: string;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  maxLength?: number;
  value?: number;
  defaultValue?: number;
  disabled?: boolean;
  showButtons?: boolean;
}
export const EditNumber: React.FC<EditNumberModel> = ({
  title,
  onChange,
  min,
  max,
  value,
  defaultValue,
  disabled = false,
  showButtons = true,
  maxLength = 1000000000,
}) => {
  // When `value` is not supplied the caller treats this component as
  // uncontrolled: track the value internally so that `defaultValue` is shown
  // initially and the user's typed value persists between renders.
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState<number | undefined>(
    defaultValue,
  );
  const effectiveValue = isControlled ? value : internalValue;

  return (
    <div
      style={{
        flex: '1', // Flex-grow, flex-shrink, and base size of 250px
        minWidth: '250px', // Ensure a minimum width of 250px
        marginBottom: '16px', // Optional bottom margin for row spacing
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ fontSize: '14px', color: '#4b5563' }}>{title}</div>
      <InputNumber
        style={{ height: '36px', marginTop: '4px', direction: 'ltr' }}
        id="username"
        aria-describedby="username-help"
        min={min}
        max={max}
        maxLength={maxLength}
        value={effectiveValue}
        inputStyle={{ textAlign: 'right' }} // Add this line
        showButtons={showButtons}
        onChange={(e) => {
          const next = e?.value ?? 0;
          if (!isControlled) setInternalValue(next);
          onChange(next);
        }}
        disabled={disabled}
      />
    </div>
  );
};
